import React from "react";
import DragRail from "web/react/components/drag-rail/drag-rail";
import ProductCard from "web/react/components/product-card/product-card";
import analytics from "web/script/analytics/analytics";
import { ProductCardType } from "web/types/product-card";
import classnames from "classnames";
import styles from "./top-products.css";

export interface TopProductsProps {
    title: string;
    products: ProductCardType[];
}

export function TopProducts({ title, products }: TopProductsProps): JSX.Element {
    const id = "top-50-products";

    function handleDrag(): void {
        analytics.event("rail", "drag", "homepage-top-products");
    }

    return (
        <DragRail id={id} onDragStart={handleDrag} className={styles.wrapper}>
            <div className={styles.productsContainer}>
                <h2 className={classnames(styles.productCard, styles.titleCard)}>
                    <span className={styles.titleCardText}>{title}</span>
                </h2>
                {products.map((product) => {
                    return (
                        <ProductCard
                            className={styles.productCard}
                            key={product.id}
                            product={product}
                            imageSize={"feed"}
                            scrollParentId={id}
                        />
                    );
                })}
            </div>
        </DragRail>
    );
}

export default TopProducts;
